import { useDropzone } from 'react-dropzone'

import { Props } from './interfaces'
import { DragDropContainer } from './styles'

type Variant = 'normal' | 'noInput'

type DragAndDropProps = {
  variant?: Variant
  backgroundColor?: string
}

const DragAndDrop = (props: Props & DragAndDropProps) => {
  const {
    children,
    onDrop,
    accept = 'image/jpeg,image/jpg,image/png',
    defaultViewWidth,
    defaultViewHeight,
    maxSize,
    multiple,
    maxFiles,
    disabled = false,
    variant = 'normal',
    backgroundColor,
  } = props
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple,
    maxSize,
    maxFiles,
    disabled,
  })

  return (
    <DragDropContainer
      {...getRootProps({ isDragActive })}
      width={defaultViewWidth}
      height={defaultViewHeight}
      backgroundColor={backgroundColor}
    >
      {variant !== 'noInput' && <input {...getInputProps()} />}
      {children}
    </DragDropContainer>
  )
}

export default DragAndDrop
